import React, { useState, useEffect } from 'react';
import generalStyles from '@/components/General/Styles.module.scss';
import { verifyCsr } from '@/services/api/csrdata.service';
import API_STATES from '@/constants/StateConstants';
import styles from '@/components/ModifyCSR/ModifyCSR.module.scss';

const Verification = ({ isVerified = false, csrId }) => {
    const [verificationState, setVerificationState] = useState({
        status: API_STATES.none,
        error: '',
    });
    const [emailVerified, setEmailVerified] = useState(false);

    const onVerifyEmail = async () => {
        try {
            setVerificationState({
                status: API_STATES.loading,
                error: '',
            });
            const response = await verifyCsr(csrId);
            if (response.status === API_STATES.error) {
                throw new Error(response.error);
            }
            setVerificationState({
                status: API_STATES.success,
                error: '',
            });
            setEmailVerified(true);

            setTimeout(() => {
                setVerificationState({
                    status: API_STATES.none,
                    error: '',
                });
            }, 5000);
        } catch (error) {
            setVerificationState({
                status: API_STATES.error,
                error: 'Failed to verify email',
            });
        }
    };

    useEffect(() => {
        setEmailVerified(isVerified);
    }, [isVerified]);

    return (
        <div>
            {emailVerified ? (
                <span className={`${generalStyles.successMessage} ${styles.verification_message}`}>
                    User Email is Verified
                </span>
            ) : (
                <span className={`${generalStyles.errorMessage} ${styles.verification_message}`}>
                    User Email is <b>not</b> Verified.
                </span>
            )}
            {!emailVerified && (
                <div className={styles.verification_button_container}>
                    <button
                        data-test="confirm-email-verification-btn"
                        className={generalStyles.smallButton}
                        onClick={onVerifyEmail}
                    >
                        Verify
                    </button>
                    {verificationState.status === API_STATES.loading ? (
                        <span>Loading...</span>
                    ) : verificationState.status === API_STATES.success ? (
                        <span className={generalStyles.successMessage}>Email Verified Successfully</span>
                    ) : verificationState.status === API_STATES.error ? (
                        <span className={generalStyles.errorMessage}>{verificationState.error}</span>
                    ) : null}
                </div>
            )}
        </div>
    );
};

export default Verification;
